module.exports = __webpack_public_path__ + "static/media/adam-idle.d9a17a68.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/adam-idle.png
// module id = 36
// module chunks = 0